import { GroupEntityService } from '@views/pages/apps/general/groups/services/group-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class GroupResolver implements Resolve<boolean> {

    constructor(private groupEntityService: GroupEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.groupEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.groupEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }

}
